import React, { useContext, useEffect, useState } from 'react';
import './index.scss';
import PropTypes from 'prop-types';
import SkipTo from '../common/Tag/SkipTo';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import AuthenticatedModal from '../HomeDeliveryNew/AuthenticateModal';
import AcceptedPharmacies from '../SignUpLanding/AcceptedPharmacies';
import TrustpilotMain from './Trustpilot';
import FaqsAccordian from './Faqs';
import {
  SIGN_UP_DESC,
  SIGN_UP_DESC_ES,
  SIGN_UP_TITLE,
  SIGN_UP_TITLE_ES,
  SIGNUP_PAGE_SIGNUP_MODAL
} from '../../constants/defaults';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { AuthContext } from '../../Contexts';

const SingleCareApps = props => {
  const { t, i18n } = useTranslation();
  let isEs = _.isEqual(i18n.language, 'es');
  const history = useHistory();
  const params = new URLSearchParams(props.location.search);
  const [openSignupModal, setSignupModal] = useState(false);
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  useEffect(() => {
    document.body.style.overflow = openSignupModal ? 'hidden' : '';
  }, [openSignupModal]);

  useEffect(() => {
    isLoggedIn && history.push(_.withLocale(i18n.language, '/'));
    if (params.get('signupModal') == 'true') {
      handleSignupClick();
    }
  }, []);

  const handleSignupClick = () => {
    setSignupModal(true);
    let { signUpPath, signUpPathWithInvite } = _.getSignUpPath(
      SIGNUP_PAGE_SIGNUP_MODAL
    );
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpButtonClick',
      ...signUpPath
    });
    _.triggerGTMVirtualPageViewEvent({
      event: 'signupModalOpen',
      ...signUpPathWithInvite
    });
  };

  return (
    <main>
      <Helmet>
        <script
          type="text/javascript"
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          className="optanon-category-C0001"
          async
        ></script>
        <title>{isEs ? SIGN_UP_TITLE_ES : SIGN_UP_TITLE}</title>
        <meta
          name="description"
          content={isEs ? SIGN_UP_DESC_ES : SIGN_UP_DESC}
        />
        <meta
          name="keywords"
          content={isEs ? 'descuentos en medicamentos - 140' : ''}
        />
      </Helmet>
      <section className="signUpContainer">
        {openSignupModal && (
          <div className="mainModal afterSignupmodal">
            <div
              className="transparentBg"
              onClick={() => setSignupModal(false)}
            ></div>
            <div className="signUpModal">
              <AuthenticatedModal
                hideAuthenticateModal={() => setSignupModal(false)}
              />
            </div>
          </div>
        )}
        <section className="signUpInfoContainer">
          <SkipTo>
            <section className="signUpTopInfo">
              <h1>
                {t('Members save the most on their Rx')}
                <br className="desktop-only" />
                <br className="mobile-only" />
                {isEs ? (
                  <>
                    {t('sign up')} <span>{t('Free')}</span>
                  </>
                ) : (
                  <>
                    <span>{t('Free')}</span> {t('sign up')}
                  </>
                )}
              </h1>
              <ul>
                <li>{t('Save up to 80% on your prescriptions')}</li>
                <li>{t('Unlock members-only discounts')}</li>
                <li>
                  {t('Earn extra savings each time you fill a prescription')}
                </li>
              </ul>
              {!isLoggedIn && (
                <button
                  className="signUpBtn"
                  onClick={() => {
                    setSignupModal(true);
                    let { signUpPath, signUpPathWithInvite } = _.getSignUpPath(
                      SIGNUP_PAGE_SIGNUP_MODAL
                    );
                    _.triggerGTMVirtualPageViewEvent({
                      event: 'signUpButtonClick',
                      ...signUpPath
                    });
                    _.triggerGTMVirtualPageViewEvent({
                      event: 'signupModalOpen',
                      ...signUpPathWithInvite
                    });
                  }}
                >
                  {t('Sign up, it’s free')}
                </button>
              )}
              <div className="ladyBg">
                <LazyLoadImage
                  src="/content/images/signup/lady.png"
                  width="348"
                  height="588"
                  alt=""
                />
              </div>
            </section>
          </SkipTo>
        </section>

        <section className="howItWorks">
          <div className="innerContainer">
            <h2>{t('How SingleCare works')}</h2>
            <p className="subHeading">
              {t(
                'SingleCare works directly with pharmacies to negotiate up to 80% off'
              )}
              <br className="desktop-only" />
              {t(
                'prescription prices. We pass these savings onto you, free of charge.'
              )}
            </p>
            <div className="stepProcess">
              <div className="steps">
                <div className="icons">
                  <LazyLoadImage
                    src="/content/images/signup/step1.svg"
                    width="104"
                    height="87"
                    className="desktop-only"
                    alt=""
                  />
                  <LazyLoadImage
                    src="/content/images/signup/mobileStep1.svg"
                    width="57"
                    height="54"
                    className="mobile-only"
                    alt=""
                  />
                </div>
                <h3>{t('Search prescriptions')}</h3>
                <p>
                  {t('See our available discounted prices for')}
                  <br className="desktop-only" />
                  {t('your prescriptions.')}
                </p>
              </div>
              <div className="steps">
                <div className="icons">
                  <LazyLoadImage
                    src="/content/images/signup/step2.svg"
                    width="125"
                    height="86"
                    className="desktop-only"
                    alt=""
                  />
                  <LazyLoadImage
                    src="/content/images/signup/mobileStep2.svg"
                    width="62"
                    height="48"
                    className="mobile-only"
                    alt=""
                  />
                </div>
                <h3>{t('Get a free coupon')}</h3>
                <p>
                  {t('It can be used at participating')}
                  <br className="desktop-only" />
                  {t('pharmacies near you.')}
                </p>
              </div>
              <div className="steps">
                <div className="icons">
                  <LazyLoadImage
                    src="/content/images/signup/step3.svg"
                    width="105"
                    height="92"
                    className="desktop-only"
                    alt=""
                  />
                  <LazyLoadImage
                    src="/content/images/signup/mobileStep3.svg"
                    width="59"
                    height="56"
                    className="mobile-only"
                    alt=""
                  />
                </div>
                <h3>{t('Show your pharmacist')}</h3>
                <p>
                  {t('They’ll input the magic numbers to apply')}
                  <br className="desktop-only" />
                  {t('the discount.')}
                </p>
              </div>
            </div>
            {!isLoggedIn && (
              <button className="signUpBtn" onClick={handleSignupClick}>
                {t('Sign up for free')}
              </button>
            )}
          </div>
        </section>

        <AcceptedPharmacies />

        <TrustpilotMain />

        <FaqsAccordian />

        <section className="memberSection">
          <h2>{t('Members get access to our lowest prices!')}</h2>
          {!isLoggedIn && (
            <button
              className="signUpBtn"
              onClick={() => {
                setSignupModal(true);
                let { signUpPath, signUpPathWithInvite } = _.getSignUpPath(
                  SIGNUP_PAGE_SIGNUP_MODAL
                );
                _.triggerGTMVirtualPageViewEvent({
                  event: 'signUpButtonClick',
                  ...signUpPath
                });
                _.triggerGTMVirtualPageViewEvent({
                  event: 'signupModalOpen',
                  ...signUpPathWithInvite
                });
              }}
            >
              {t('Sign up for free')}
            </button>
          )}
          <div className="imageContainer mobile-only">
            <LazyLoadImage
              src="/content/images/apps/pill-bottle.png"
              height="120"
              width="106"
              alt=""
            />
          </div>
        </section>
      </section>
    </main>
  );
};

SingleCareApps.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  history: PropTypes.any
};

export default SingleCareApps;
